export const KIOSK_NAV_STEPS = Object.freeze([
  {
    id: 1,
    key: "userLogin",
    labelKey: "kiosk.nav_step_login"
  },
  {
    id: 2,
    key: "mainScreen",
    labelKey: "kiosk.nav_step_select"
  },
  {
    id: 3,
    key: "passAction",
    labelKey: "kiosk.nav_step_action"
  },
  {
    id: 4,
    key: "activePass",
    labelKey: "kiosk.nav_step_active"
  }
])
